module.exports = __webpack_public_path__ + "static/media/Panton-SemiBold.f575f5aa.woff2";